// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"style_SectionTitle__YDq9B"};